import { AuthController } from '@/plugins/api/auth/auth'

export class AuthService {
  constructor(ctx) {
    this.auth = new AuthController(ctx)
  }
}
